import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';

import { UploadFileType } from '../../_models/models';
import { ListType } from '../upload-file/upload-file.component';

@Component({
  selector: 'app-upload-csv',
  templateUrl: './upload-csv.component.html',
  styleUrls: ['./upload-csv.component.less'],
})
export class UploadCsvComponent {
  @Input() uploadText = 'Upload CSV';
  @Input() hideRemoveBtn = false;
  @Input() isLoading = false;
  @Input() hasError = false;
  @Input() uploadFileInstruction = 'Click or drag file to this area to upload';
  @Input() permittedFileTypes: UploadFileType[] = [
    UploadFileType.TEXT_CSV,
    UploadFileType.APPLICATION_CSV
  ];

  @Input() set shouldClear(value: boolean) {
    if (value) {
      this.clearUpload();
    }
  }

  @Output() fileUpload: EventEmitter<NzUploadFile> = new EventEmitter<NzUploadFile>();
  @Output() fileRemove: EventEmitter<void> = new EventEmitter<void>();

  uploadedFileName: string | null;
  listType: ListType = ListType.PICTURE_CARD;

  handleChange(event: NzUploadFile): void {
    this.fileUpload.emit(event);
    this.uploadedFileName = event.file?.name;
  }

  // uploadingFunc(file: NzUploadFile): void {
  //   this.fileUpload.emit({ file: file });
  //   this.uploadedFileName = file.name;
  // }

  removeFile(): void {
    this.fileRemove.emit();
    this.uploadedFileName = null;
  }

  private clearUpload(): void {
    this.uploadedFileName = null;
  }
}
